import { useTranslation } from 'react-i18next';
import { DeleteButton } from '../../../../components/buttons/DeleteButton';
import { useEffect } from 'react';

export const OrderFormTable = ({ products, onRemove }) => {

    const { t } = useTranslation('order');

    useEffect(() => {
        products.forEach((it, index) => {
            let element = document.getElementById('amount-' + index);
            if (element) {
                element.value = it.amount;
                if (it.amount != null && it.amount > 0) {
                    element.className = 'form-control';
                } else {
                    element.className = 'form-control is-invalid';
                }
            }
        });
    }, [products]);

    return (
        <div className={'order-products-table'}>
            <table>
                <thead>
                <tr>
                    <th className={'td'}>{t('form.product')}</th>
                    <th className={'td'}>{t('form.amount')}</th>
                    <th className={'td'}></th>
                </tr>
                </thead>
                <tbody>
                {products == null || products.length === 0 ? <></> : products.map((product, index) => {
                    return (
                        <tr key={index}>
                            <td className={'td'}>{product.title}</td>
                            <td className={'td'}>
                                <input type={'number'}
                                       className={'form-control'}
                                       id={'amount-' + index}
                                       defaultValue={product.amount}
                                       onChange={(event) => product.amount = +event.target.value} />
                            </td>
                            <td className={'td'}>
                                <DeleteButton onClick={() => onRemove(index)} />
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};